module.exports = __webpack_public_path__ + "front/img/7-1.08c3c2f4.png";